import React, { useEffect } from "react";

function Pod() {

    useEffect(() => {
        window.location.href = "https://www.zimworx.com/podcasts/";
    }, []);

    return (
        <div>
        </div>
    );
}

export default Pod;